import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { fmtErr } from "@/lib/api";
import { toast } from "sonner";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/app");
    } catch (err) {
      toast.error(fmtErr(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-white text-slate-900 flex items-center justify-center p-6 font-[Inter,system-ui,sans-serif]">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center mb-8">
          <img src="/recruitsift-logo.png" alt="RecruitSift" className="h-10 w-auto"/>
        </Link>
        <form onSubmit={submit} className="bg-white border border-slate-200 rounded-2xl p-8 shadow-sm" data-testid="login-form">
          <h1 className="text-2xl font-bold text-slate-900 mb-1">Sign in</h1>
          <p className="text-sm text-slate-500 mb-6">Recruiter workspace access</p>
          <div className="space-y-4">
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Email</label>
              <input data-testid="login-email" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required className="w-full mt-1 px-3 py-2.5 rounded-lg border border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none text-sm"/>
            </div>
            <div>
              <div className="flex items-center justify-between">
                <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Password</label>
                <Link to="/forgot-password" data-testid="forgot-password-link" className="text-xs text-blue-600 hover:text-blue-700 font-medium">Forgot password?</Link>
              </div>
              <input data-testid="login-password" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required className="w-full mt-1 px-3 py-2.5 rounded-lg border border-slate-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none text-sm"/>
            </div>
          </div>
          <button data-testid="login-submit" disabled={loading} className="mt-6 w-full py-2.5 rounded-lg bg-slate-900 hover:bg-slate-800 text-white font-semibold text-sm disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <div className="mt-5 text-center text-sm text-slate-500">
            No account? <Link to="/register" className="text-blue-600 hover:text-blue-700 font-medium">Create one</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
